export const locale = {
    lang: 'en',
    data: {
        'Client': 'Client',
        'Employee': 'Employee',
    }
};
